import {useCallback, useEffect, useState} from 'react'
import {Badge, Button} from 'antd'
import {AppstoreOutlined, ShoppingCartOutlined} from '@ant-design/icons'
import {useLocation, useNavigate} from 'react-router-dom'
import {pathConstent, useUserInfoContext} from '@/store/userInfo'
import Search from './Search'
import Menu from './Menu'
import MenuSdgj from './MenuSdgj'
import config from '@/config/env'
import style from '../style.module.less'
import logo from '../images/top-logo.png'
import {getUserInfo} from "@/utils/common";

const menusData = [
    {title: '首页', key: '/',code:'sy'},
    {title: '首页', key: '/',code:'sdgjsy'},
    {title: '全品类产品', key: '/product', code: pathConstent.QPLCP},
    {title: 'DCA爆款机', key: '/dca', code: 'dcabkj'},
    {title: '省代产品', key: '/sdcp', code: 'sdcp'},
    {title: '蓝红手动工具🔥', key: '/sdgjcp', code: 'sdgjcp'},
    {title: '部件目录区', key: '/bjmlq', code: 'bjmlqpc'},
    {title: '工作台', key: '/center/gzt', code: 'gzt'},
]

const Top = () => {
    const {shopcarCount, baseInfo, hasPermission} = useUserInfoContext()
    const navigator = useNavigate()
    const location = useLocation()
    const userInfo = getUserInfo()
    const [menus, setMenus] = useState([{title: '首页', key: '/'}])

    const handleMenu = useCallback((row) => {
        navigator(row.key)
    }, [navigator])

    // 打开购物车
    const handleShopCar = useCallback(() => {
        navigator('/shopcar?t=' + Date.now())
    }, [navigator])

    // 更新用户基本信息，获取权限数据
    useEffect(() => {
        if (baseInfo.qx && baseInfo.qx.webqx) {
            if (!config.staticMenus) {
                const webqx = (JSON.parse(baseInfo.qx.webqx) || []).find(m => m.hmmc === '导航栏')
                if (webqx && webqx.children) {
                    const menusList = [];
                    menusList.push({title: '首页', key: '/'});
                    setMenus(menusList.concat(menusData.filter(m => !m.code || webqx.children.some(c => c.hmbh === m.code))));
                }
            }
        }
    }, [baseInfo])

    return (
        <div className={style.top}>
            <div className='layout-container'>
                <div className='flex align-center'>
                    <div className='flex-1 flex align-center'>
                        <a  className='flex align-center'>
                            <img src={logo} alt="" className={`${style['top-logo']} cursor-pointer`}/>
                            <div className='ml-10 font-20 font-700 cursor-pointer text-333'>东成精品电动工具，欢迎您！
                            </div>
                        </a>
                    </div>
                    <Search filterFlag/>
                    {
                        hasPermission('gwc') && (
                            <Button className={`${style.shopcar} ml-20`} onClick={handleShopCar}>
                                <Badge count={shopcarCount} size="small">
                                    <ShoppingCartOutlined style={{fontSize: 20}}/>
                                </Badge>
                                <span className='ml-4'>我的购物车</span>
                            </Button>
                        )
                    }
                </div>
                <div className={`flex ${style['top-menu']} mt-20 align-center`}>
                    {/* <div className={`${style['top-all-category']} flex align-center plr-16`}>
                        <AppstoreOutlined className='font-20 mr-12'/>
                        <span>全部商品分类</span>
                        <Menu/>
                    </div> */}
                    {
                        menus.map(row => <div onClick={() => handleMenu(row)} key={row.key}
                                              className={`plr-15 ptb-6 cursor-pointer ${style['top-router-menu']} ${location.pathname === row.key && style.active}`}>{row.title}</div>)
                    }
                </div>
            </div>
        </div>
    )
}

export default Top
